module.exports = require("./as-IN.js");